import { FaShippingFast, FaCreditCard, FaUndoAlt, FaCheckCircle, FaGift, FaLock, FaHeadset, FaLeaf } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaShippingFast />, // Truck icon
    title: 'Free Shipping',
    description: 'Capped at $39 per order',
  },
  {
    id: 2,
    icon: <FaCreditCard />, // Card icon
    title: 'Card Payment',
    description: '12 Months Installments',
  },
  {
    id: 3,
    icon: <FaUndoAlt />, // Return icon
    title: 'Easy Returns',
    description: 'Shop With Confidence',
  },
  {
    id: 4,
    icon: <FaCheckCircle />, // Check icon
    title: 'Quality Guarantee',
    description: 'Our Commitment to Quality',
  },
  {
    id: 5,
    icon: <FaGift />, // Gift icon
    title: 'Special Offers',
    description: 'Exclusive Deals & Discounts',
  },
  {
    id: 6,
    icon: <FaLock />, // Lock icon
    title: 'Secure Checkout',
    description: 'Safe & Protected Payments',
  },
  {
    id: 7,
    icon: <FaHeadset />, // Headset icon
    title: '24/7 Support',
    description: 'Friendly Customer Service',
  },
  {
    id: 8,
    icon: <FaLeaf />, // Leaf icon
    title: 'Fresh Ingredients',
    description: 'Baked Fresh Daily',
  },
];

export default features;